<template>
    <article class="status--check">
        <p>{{ title }}</p>
        <figure v-if="name != 'confirmed'" ref="check"></figure>
        <figure v-else class="status-loading"></figure>
    </article>
</template>
<script>
import { loadAnimation } from "lottie-web";
import {onMounted, ref} from "vue";
import success from "@/assets/lottie/success";
export default {
    props: {
        title: {
            type: String,
        },
        name: {
            type: String,
        },
    },
    setup(props) {
        const check = ref(null);
        function loadLottie() {
            if (props.name !== "confirmed") {
                loadAnimation({
                    container: check.value,
                    renderer: "svg",
                    loop: false,
                    autoplay: true,
                    animationData: success,
                    rendererSettings: {
                        progressiveLoad: true,
                        hideOnTransparent: true,
                    },
                });
            }
        }
        onMounted(() => {
            loadLottie();
        });
        return {
            loadLottie,
            check,
        };
    },
};
</script>
<style lang="scss" scoped>
article.status--check {
  width: 100%;
  background: #fffdfb;
  border: 1px solid rgba(108, 108, 108, 0.15);
  border-radius: 0.4rem;
  padding: 1.5rem 2rem;
  font-size: 14px;
  line-height: 135%;
  color: $primary-text-color;
  display: flex;
  justify-content: space-between;
}
figure {
  height: 2rem;
  width: 2rem;
  /* margin-right: 0.9rem; */
}
.status-loading {
  border-width: 0.2rem;
  border-style: solid;
  border-color: $primary-color;
  border-radius: 50%;
  animation: rotate 0.5s infinite linear;
  &::before {
    position: absolute;
    height: 1rem;
    top: -0.3rem;
    left: -0.3rem;
    right: -0.3rem;
    content: "";
    background-color: $white;
  }
}
</style>